import React from "react";
import usePageTitle from "../../hooks/usePageTitle";
import DeleteAccountMethod1 from "../../assets/Screens/DeleteAccount1.png";
import DeleteAccountMethod2 from "../../assets/Screens/DeleteAccount2.png";
import "./delete-account.css";

export default function DeleteAccount() {
  usePageTitle("Удаление аккаунта – СобеседникИИ");
  return (
    <div className="delete-account w-full px-[24px] pt-[40px] md:pt-[60px] pb-[40px]">
      <div className="max-w-[995px] w-full mx-auto flex flex-col gap-[40px]">
        <h1 className="font-semibold text-[20px] md:text-[32px] leading-[24px] md:leading-[40px] text-center font-legal">
          Удаление аккаунта
        </h1>

        <section id="methods">
          <h2>Способы удаления</h2>

          <section id="method-1">
            <h3>Способ 1: Через приложение (рекомендуется)</h3>

            <ol className="list-decimal">
              <li>
                Откройте приложение <b>СобеседникИИ</b>;
              </li>
              <li>
                Перейдите в раздел «<b>Настройки</b>»;
              </li>
              <li>
                Нажмите на кнопку «<b>Удалить аккаунт</b>»;
                <img
                  src={DeleteAccountMethod1}
                  alt="Удаление аккаунта"
                  width={220}
                />
              </li>
              <li>
                Подтвердите удаление в диалоговом окне.
                <img
                  src={DeleteAccountMethod2}
                  alt="Подтверждение удаления аккаунта"
                  width={220}
                />
              </li>
            </ol>
          </section>

          <section id="method-2">
            <h3>Способ 2: Через электронную почту</h3>

            <p>
              Отправьте запрос на:{" "}
              <a href="mailto:support@sobesednikai.ru">
                support@sobesednikai.ru
              </a>
            </p>
            <p>
              В теме письма укажите «<b>Удаление аккаунта</b>».
            </p>
            <p>В тексте письма сообщите:</p>
            <ul className="list-disc ml-[20px]">
              <li>
                Адрес электронной почты, на которой зарегистрирован аккаунт;
              </li>
              <li>Имя пользователя;</li>
              <li>Причину удаления.</li>
            </ul>
          </section>
        </section>

        <section id="what-will-be-deleted">
          <h2>Какие данные будут удалены?</h2>

          <p>
            Удаление аккаунта является необратимой операцией. Все Ваши данные
            будут безвозвратно утеряны. Активные подписки будут автоматически
            отменены. Восстановление аккаунта невозможно.
          </p>

          <p className="font-bold">Полностью удалятся:</p>
          <ul className="list-disc ml-[20px]">
            <li>Персональные данные профиля;</li>
            <li>История чатов и сообщений;</li>
            <li>Настройки приложения;</li>
            <li>Загруженные файлы и медиа;</li>
            <li>История подписок и платежей;</li>
            <li>Данные интеграций.</li>
          </ul>
        </section>
      </div>
    </div>
  );
}
